import {
  NavigationGrid,
  ROUTES,
  // @ts-ignore
} from "@projectdiction/common-react";

// @ts-ignore
import { useTranslation } from "react-i18next";

function FillblankMain() {
  const { t } = useTranslation();

  return (
    <NavigationGrid
      title={t("exercises.fillblank.titles.fillblank")}
      data={[
        {
          title: t("exercises.fillblank.titles.solver"),
          route: ROUTES.EXERCISES.FILLBLANK.SOLVE(),
          description: "",
          label: t("buttons.navigation.go"),
        },
        {
          title: t("exercises.fillblank.titles.creator"),
          route: ROUTES.EXERCISES.FILLBLANK.CREATOR.HOME,
          description: "",
          label: t("buttons.navigation.go"),
        },
      ]}
    />
  );
}

export default FillblankMain;
